// store.ts
import { configureStore } from "@reduxjs/toolkit";
import userReducer, { UserState } from "./slices/userSlices";

// Load state from localStorage
const loadState = (): { user: UserState } | undefined => {
  try {
    const serializedState = localStorage.getItem("reduxData");
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Failed to load state:", err);
    return undefined;
  }
};

// Save state to localStorage
const saveState = (state: RootState) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("reduxData", serializedState);
  } catch (err) {
    console.error("Failed to save state:", err);
  }
};

const preloadedState = loadState();

export const store = configureStore({
  reducer: {
    user: userReducer,
  },
  preloadedState, // ✅ now matches { user: UserState }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Persist whenever state changes
store.subscribe(() => {
  saveState(store.getState());
});
